/**
 * Converts a number to a fixed number of decimal places.
 *
 * Rounds the given value to the specified number of decimal places and returns
 * it as a number (not a string). Useful for preventing floating-point precision
 * issues when displaying or comparing numbers.
 *
 * @param value - The number to round
 * @param decimalPlaces - The number of decimal places to round to
 * @returns The rounded number
 *
 * @example
 * toFixedOrInteger(3.14159, 2); // Returns 3.14
 * toFixedOrInteger(10, 2); // Returns 10
 */
const toFixedOrInteger = (value: number, decimalPlaces: number) =>
  Number(value.toFixed(decimalPlaces));

export default toFixedOrInteger;
